/// <amd-module name="Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestPlanCloneProgressReducer } from "./TestPlanCloneProgressReducer";
import { ITestPlanCloneProgressAwareState } from "./TestPlanCloneProgressContracts";
import { TestPlanCloneProgressSaga } from "./TestPlanCloneProgressSaga";
import { TestPlanCloneProgressActions } from "./TestPlanCloneProgressActions";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";

/**
 * Redux dynamic module for the clone operation
 */
export function TestPlanCloneProgressModule(planId: number, opId: number): ISagaModule<ITestPlanCloneProgressAwareState> {
    let initialActions = [TestPlanCloneProgressActions.getCloneOpState(planId, opId, true)];
    return {
        id: "clone-progress-state",
        reducerMap: {
            testPlanCloneProgressState: TestPlanCloneProgressReducer,
            testHubRefreshState: TestHubRefreshReducer
        },
        sagas: [TestPlanCloneProgressSaga],
        initialActions: initialActions
    };
}
